import { NgModule } from '@angular/core';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { SharedModule } from '../Shared/shared.module';

import { Case360Component } from './case360.component';
import { CaseinfoComponent } from './caseinfo/caseinfo.component';
import { CasemessageComponent } from './casemessage/casemessage.component';
import { CasespecimenComponent } from './casespecimen/casespecimen.component';
import { OtherinfoComponent } from './otherinfo/otherinfo.component';
import { CaseauditComponent } from './caseaudit/caseaudit.component';
import { CasehistoryComponent } from './casehistory/casehistory.component';
import { CaseclaimComponent } from './caseclaim/caseclaim.component';
import { FtpfilesComponent } from '../ftpfiles/ftpfiles.component';
@NgModule({
  declarations: [
    Case360Component,
    CaseinfoComponent,
    CasemessageComponent,
    CasespecimenComponent,
    OtherinfoComponent,
    CaseauditComponent,
    CasehistoryComponent,
    CaseclaimComponent,
    FtpfilesComponent,
  ],
  imports: [
    SharedModule,
    ScrollingModule,
  ],
  exports: [Case360Component]
})
export class Case360Module {}
